'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicSdk = require('@gig/magic-sdk');
var tslib = require('tslib');

var onCountryChange = function (value, _, setField) { return tslib.__awaiter(void 0, void 0, void 0, function () {
    var countries, country;
    return tslib.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'getCountries')()];
            case 1:
                countries = (_a.sent());
                country = countries.countries.find(function (_a) {
                    var code = _a.code;
                    return code === value;
                });
                if (country && country.currency) {
                    setField({
                        id: 'currency',
                        value: country.currency,
                        isValid: true,
                        touched: false,
                        isValidationPending: false,
                    });
                }
                return [2 /*return*/];
        }
    });
}); };
function currency(isLockedCurrency) {
    var _this = this;
    return {
        id: 'currency-wrapper',
        component: 'magic-ui-form-field',
        validationBase: 'currency',
        isDataField: false,
        testId: 'step2-currency',
        children: [
            {
                id: 'currency',
                isDataField: true,
                component: 'magic-ui-dropdown',
                triggers: {
                    country: onCountryChange,
                },
                properties: {
                    placeholder: magicCommon.translate('sign-up-step-two.currency.placeholder'),
                    disabled: isLockedCurrency,
                },
                preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                    var countries, options;
                    return tslib.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'getCountries')()];
                            case 1:
                                countries = (_a.sent());
                                if (!countries) {
                                    return [2 /*return*/, { options: [], value: '' }];
                                }
                                options = magicCommon.uniqueValues(countries.countries
                                    .map(function (_a) {
                                    var currency = _a.currency;
                                    return currency;
                                }) // get currency codes
                                    .filter(Boolean))
                                    .sort()
                                    .map(function (currency) { return ({
                                    name: magicCommon.translate("sign-up-step-two.currency." + currency),
                                    value: currency,
                                }); });
                                return [2 /*return*/, {
                                        options: options,
                                    }];
                        }
                    });
                }); },
            },
        ],
    };
}

exports.currency = currency;
